import React from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import PropTypes from 'prop-types';

const MatchClock = ({ matchClock, withSeconds }) => {
  dayjs.extend(duration);
  const numberMatchClock = parseInt(matchClock);
  if (!isFinite(numberMatchClock) || numberMatchClock < 0) {
    return null;
  }

  const durationTime = dayjs.duration(numberMatchClock, 'seconds');
  const minutes = Math.floor(durationTime.asMinutes()).toString().padStart(2, '0');
  const seconds = durationTime.seconds().toString().padStart(2, '0');

  if (!withSeconds) {
    return <span>{minutes}’</span>;
  }

  return (
    <span>
      {minutes}:{seconds}
    </span>
  );
};

MatchClock.propTypes = {
  matchClock: PropTypes.string.isRequired,
  withSeconds: PropTypes.bool,
};

export default MatchClock;
